import { AuthenticationProvider } from '@solinkcorp/authentication';
import Loadable from 'components/Loadable';
import MobileLanding from 'components/MobileLanding/MobileLanding';
import { UnsavedChangesProvider } from 'components/UnsavedChanges/UnsavedChangesProvider';
import PageLoadingSpinner from 'loadingIndicator/PageLoadingSpinner';
import { createBrowserRouter } from 'react-router-dom';
import ErrorBoundary from 'src/core/components/ErrorBoundary';
import Alarm from './components/PublicPages/AlarmPage';
import Share from './components/PublicPages/SharePage';
import VirtualTablet from './components/PublicPages/VirtualTabletPage';

const AuthenticatedAppWrapper = Loadable({
  loader: () => import('./components/AuthenticatedApp/AuthenticatedAppWrapper'),
  loading: PageLoadingSpinner,
});

const getMobileOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  // iOS 13 compatible & iPad detection from: https://stackoverflow.com/a/58064481
  if (
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !(window as any).MSStream
  ) {
    return 'iOS';
  }
  return 'unknown';
};

const mobileOS = getMobileOS();

export const router = createBrowserRouter([
  // Public Routes
  {
    path: '/share/:shareId',
    element: <Share />,
  },
  {
    path: '/alarm/:alarmId',
    element: <Alarm />,
  },
  {
    path: '/virtual-tablet/:siteId',
    element: <VirtualTablet />,
  },
  // Private Routes
  {
    path: '*',
    element: (
      <UnsavedChangesProvider>
        <AuthenticationProvider>
          <ErrorBoundary>
            {mobileOS === 'Android' || mobileOS === 'iOS' ? (
              <MobileLanding />
            ) : (
              <AuthenticatedAppWrapper />
            )}
          </ErrorBoundary>
        </AuthenticationProvider>
      </UnsavedChangesProvider>
    ),
  },
]);
